// extracted by mini-css-extract-plugin
export default {"drawerTitle":"drawerTitle--j6rc8","taskChange":"taskChange--VQdxt","markerAnimationScale":"markerAnimationScale--TFgEy"};